<template>
  <div class="content">
    <div class="background-image-search" v-bind:style="'background-image: url(' + recipeData.image.absoluteUri + ');'"></div>
    <!-- /.background-image-search -->
    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <RouteBreadcrumb />
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/recipe/add-recipe" v-if="isAdmin"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add New Recipe</base-button></router-link>
          <base-button v-if="!isAdmin" type="secondary" size="sm" class="btn-secondary--alt">Request Edit Access</base-button>
          <router-link :to="editLink" v-if="isAdmin"><base-button :to="editLink" v-if="isAdmin" type="secondary" size="sm" class="btn-secondary--alt">Edit Recipe</base-button></router-link>
          <base-button v-if="isAdmin" @click="handleDelete" type="warning" size="sm" class="edit" icon><i class="far fa-trash-alt"></i></base-button>
        </b-col>
      </b-row>
    </base-header>
    <div v-show="this.isLoading" class="loading">
      <loading-panel></loading-panel>
    </div>
    <b-container id="recipePrintDiv" class="container--md mt--6">
      <div>
        <recipe-header :recipeData="recipeData" :recipeImages="recipeData.recipeImages"></recipe-header>
        <recipe-stats :recipeData="recipeData" :times="times"></recipe-stats>
        <recipe-ingredients v-if="recipeData.recipeIngredients && recipeData.recipeIngredients.length > 0" 
          :key="recipeData.id"
          :recipe="recipeData"
          :ingredients="recipeData.recipeIngredients"
          @changeNumberOfServings="changeNumberOfServings($event)"></recipe-ingredients>
        <recipe-subrecipes :recipeData="recipeData" v-if="this.subRecipes.length > 0"></recipe-subrecipes>
        <b-row class="mb-5 row--instructions">
          <b-col lg="6">
            <recipe-instructions :recipeData="recipeData"></recipe-instructions>
          </b-col>

          <b-col lg="6">
            <recipe-comments :recipeId="recipeId"></recipe-comments>
          </b-col>
        </b-row>
        <b-row class="mb-5 row--instructions" v-if="recipeData.recipeAttachments && recipeData.recipeAttachments.length > 0">
          <b-col lg="12">
            <recipe-attachments :recipeData="recipeData"></recipe-attachments>
          </b-col>
        </b-row>
        <b-row class="mb-5 row--instructions">
          <b-col sm="12" md="6" v-if="recipeData.notes && recipeData.notes.length > 0">
            <recipe-notes :recipeData="recipeData"></recipe-notes>
          </b-col>
          <b-col sm="12" md="6" v-if="recipeData.recipeLinks && recipeData.recipeLinks.length > 0">

            <recipe-links :recipeData="recipeData"></recipe-links>
          </b-col>
        </b-row>

        <similar-recipes :recipeId="recipeId"></similar-recipes>

        <similar-collections :recipeId="recipeId"></similar-collections>
      </div>
    </b-container>
  </div>
</template>

<script>
import StatsCard from '@/components/Cards/StatsCard'
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import RecipeHeader from '@/views/Recipe/RecipeHeader';
import RecipeStats from '@/views/Recipe/RecipeStats';
import RecipeIngredients from '@/views/Recipe/RecipeIngredients';
import RecipeInstructions from '@/views/Recipe/RecipeInstructions';
import RecipeAttachments from '@/views/Recipe/RecipeAttachments';
import RecipeComments from '@/views/Recipe/RecipeComments';
import RecipeNotes from '@/views/Recipe/RecipeNotes';
import RecipeLinks from '@/views/Recipe/RecipeLinks';
import SimilarRecipes from '@/views/Recipe/SimilarRecipes';
import SimilarCollections from '@/views/Recipe/SimilarCollections';
import Settings from '@/whipstir';
import RecipeSubrecipes from '@/views/Recipe/RecipeSubRecipes';
import LoadingPanel from '../../components/LoadingPanel.vue';
import swal from 'sweetalert2'

export default {
  components: {
    RouteBreadcrumb,
    RecipeHeader,
    RecipeStats,
    RecipeIngredients,
    RecipeInstructions,
    RecipeAttachments,
    RecipeComments,
    RecipeNotes,
    RecipeLinks,
    SimilarRecipes,
    SimilarCollections, 
    Settings,
    RecipeSubrecipes,
    LoadingPanel
  },
  data() {
    return {
      id: null,
      lang: 'en',
      recipeId: 0,
      editLink: '',
      deleteLink: '',
      times: 1
    };
  },
  computed: {
    recipeData() {
      const recipeCurrent = this.$store.state.recipes.current;
      if ( recipeCurrent.image === undefined || recipeCurrent.image === null ) {
        recipeCurrent.image = {uri: Settings.defaultRecipeHeaderBackground}
      }
      return recipeCurrent
    },
    subRecipes() {
      return this.recipeData.recipeIngredients ? this.recipeData.recipeIngredients.filter(i => i.subRecipe) : []
    },
    isAdmin() {
      return this.$store.getters.userIsAdmin
    },
    isLoading() {
      return this.$store.getters.recipesLoading
    }
  },
  methods: {
    async onCreated() {
      this.id = this.$route.params.id;
      this.recipeId = this.$route.params.id;
      if (this.$route.query.lang) {
        this.lang = this.$route.query.lang;
      }else{
        this.lang = 'en';
      }
      this.editLink = `/recipe/edit-recipe/${this.id}?lang=${this.lang}`;
      this.deleteLink = `/recipe/edit-recipe/${this.id}?lang=${this.lang}`;
      const { dispatch } = this.$store;
      await dispatch("recipes/getById", { "recipeId": this.id, "lang": this.lang });
      dispatch("recipes/getSubRecipes", this.id);
      await dispatch('recipes/getRecipeVariations', this.id);
    },
    changeNumberOfServings(multiplier) {
      this.times = multiplier;
    },
    storeComments() {
        const commentData = {
            recipeId: this.recipeId
        };
        try {
            this.$store.dispatch("comments/getComments", commentData)
                .then(response => {
                }).catch(error => {
                    console.log('Something went wrong: ', error);
                });
        } catch (error) {
            console.log("Error: Favorite", error);
        }
    },
    handleDelete() {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          const { dispatch } = this.$store;
          dispatch("recipes/removeRecipe", this.recipeId).then(response => {
            this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Recipe Deleted'});
            this.$router.push({path: "/recipes"});
          })
          .catch(error => {
            return error;
          });
        }
      });
    }
  },
  created() {
    this.onCreated();
    this.storeComments();
  },
  watch: {
    '$route.params.id': function (id) {
      this.onCreated(id);
    },
    isLoading (newLoad, oldLoad) {
      if ( newLoad == 'failed') {
        this.$router.push({path: `/system-error?id=${this.$route.params.id}`});
      }
    },
  }
};
</script>
<style>
</style>
